<template>
  <s-layout
    :title="title"
    :layoutLeft="api && api.tree"
    :defaultBtns="defaultBtns"
    :commands="commands"
    @command="handleCommand"
  >
    <template #header-btn>
      <!-- @slot 右上角按钮插槽 -->
      <slot name="header-btn" />
    </template>
    <template #layout-left>
      <searchTree
        :treeUrl="api.tree"
        @click="nodeClick"
        :treeNodeKey="treeNodeKey"
        :handleTree="handleTree"
        :treeProps="treeProps"
        :treePlaceholder="treePlaceholder"
      ></searchTree>
    </template>
    <div class="s-table">
      <div class="s-table-right">
        <div class="table-search">
          <div class="search-left">
            <div
              :class="
                item.size === 'large'
                  ? 'search-left-large'
                  : 'search-left-small'
              "
              v-for="item in search"
              :key="item.value"
            >
              <component
                v-bind="item"
                v-bind:value="form[item.value]"
                :key="item.value"
                v-model="form[item.value]"
                :is="item.component ? item.component : 'el-input'"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                :rowKey="item?.rowKey ?? 'id'"
                :style="{ width: '100%' }"
              ></component>
            </div>
            <slot name="search-component"></slot>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
          <!-- <div class="search-right">
            <div class="search-right-keywords" v-if="search.length > 0">
              <el-input
                v-model="form.keywords"
                placeholder="请输入关键字"
                @change="handleSearch"
              />
            </div>
            <div class="search-right-filter" v-if="moreSearch.length > 0">
              <el-button @click="showMore = true"
                ><el-icon><Filter /></el-icon>高级搜索</el-button
              >
            </div>
            <div class="search-right-table" v-if="false">
              <el-button
                ><el-icon><Setting /></el-icon></el-button>
            </div>
          </div> -->
        </div>
        <div class="table-container">
          <slot name="tabs" />
          <basicTable
            ref="basicTable"
            :api="api"
            :columnBtns="columnBtns"
            :columns="columns"
            :beforeGet="beforeGet"
            :afterGet="afterGet"
            :rowKey="rowKey"
            :selection="selection"
            :actionColumn="actionColumn"
            :tableParams="tableParamsObj"
            @click="handleClick"
            @change="handleSelectionChange"
          >
            <template #column-btns="{ scope }">
              <slot name="column-btns" :scope="scope"></slot>
            </template>
          </basicTable>
        </div>
      </div>
    </div>
    <!--高级搜索侧边栏-->
    <el-drawer
      v-model="showMore"
      title="高级搜索"
      direction="rtl"
      :with-header="false"
      size="468"
    >
      <div class="more-container">
        <div class="more-container-title">
          <div class="title-left">
            <div class="title-left-icon" @click="showMore = false">
              <el-icon><ArrowRight /></el-icon>
            </div>
            <div class="title-left-text">高级搜索</div>
          </div>
          <div class="title-right">
            <el-button @click="resetSearch">重置</el-button>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </div>
        </div>
        <div class="more-container-body">
          <el-scrollbar>
            <div class="more-form">
              <div
                class="more-form-item"
                v-for="item in allSearch"
                :key="item.value"
              >
                <div class="more-form-label">{{ item.label }}</div>
                <div class="more-form-content">
                  <component
                    v-model="form[item.value]"
                    :is="item.component ? item.component : 'el-input'"
                    :placeholder="
                      item.placeholder ? item.placeholder : '请输入'
                    "
                    :start-placeholder="
                      item.startPlaceholder ? item.startPlaceholder : '开始日期'
                    "
                    :end-placeholder="
                      item.endPlaceholder ? item.endPlaceholder : '结束日期'
                    "
                    :multiple="item.multiple ? item.multiple : false"
                    :options="item.options ? item.options : []"
                    :url="item.url ? item.url : null"
                    :params="item.params ? item.params : null"
                    :field="item.field ? item.field : null"
                    :suffix-icon="item.suffix"
                    :prefix-icon="item.prefix"
                    :type="item?.type ?? 'daterange'"
                    :format="item?.format ?? 'YYYY-MM-DD'"
                    :value-format="item?.valueFormat ?? 'YYYY-MM-DD'"
                    clearable
                  ></component>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-drawer>
    <!--新增、编辑弹框-->
    <formDialog
      ref="formDialog"
      v-model="dialogVisible"
      :dialogForm="dialogForm"
      :dialogRules="dialogRules"
      :title="dialogCurTitle"
      @submit="handleSubmit"
    ></formDialog>
  </s-layout>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  ref,
  getCurrentInstance,
  watch,
  onMounted,
  defineExpose,
  nextTick,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import tableMixin from "./tableMixin";
import searchTreeMixin from "./searchTreeMixin";
import dialogMixin from "./dialogMixin";
export default defineComponent({
  name: "sTable",
  emits: {
    /** 点击table列表触发的方法
     * @event action
     * @param {string} type 触发的按钮类型
     * @param {object} item 列表当前行
     */
    action: null,
  },
  mixins: [tableMixin, searchTreeMixin, dialogMixin],
  props: {
    /** 页面标题 */
    title: {
      type: String,
      default: "",
      required: true,
    },
    /** 查询列表的表单
     * @values {component,label,placeholder,value,defaultValue,url,date1,date2}
     */
    search: {
      /*搜索表单
        {
          component:'',//渲染的组件，默认为el-input 
          label: "",//组件标签文本，必传
          placeholder: "",//组件提示
          value:'',//表单数据对象，必传
          defaultValue:'',//表单数据对象
          url:'',//组件接口请求地址
          multiple:'',//下拉等组件的多选
          options:'',//下拉等组件的options
          field:'',//用于处理后台返回的数据
          date1:'',//用于el-date-picker组件开始日期的传值
          date2:'',//用于el-date-picker组件结束日期的传值
        }
      
      */
      type: Array,
      default: () => {
        return [];
      },
    },
    moreSearch: {
      /*高级搜索的表单*/
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 页面右上角默认的按钮*/
    defaultBtns: {
      type: Object,
      default: () => {
        return {
          add: true,
        };
      },
    },
    /** 列表内默认的按钮*/
    columnBtns: {
      type: Object,
      default: () => {
        return {
          detail: true,
          edit: true,
          delete: true,
        };
      },
    },
    /** 批量操作按钮*/
    commands: {
      type: Array,
      default: () => [
        { label: "删除选中", value: "删除选中" },
        { label: "删除全部", value: "删除全部" },
      ],
    },

    /** 再点击页头按钮的时候进行校验需返回Boolean*/
    beforeCommand: {
      type: Function,
      default: null,
    },
    /** 编辑、新增弹框表单保存之前*/
    beforeSave: {
      type: Function,
      default: null,
    },
    /** 请求详情数据之后的操作*/
    afterGetDetail: {
      type: Function,
      default: null,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const basicTable = ref();
    const formDialog = ref();
    const state = reactive({
      form: {},
      tableParamsObj: {},
      showMore: false,
      allSearch: props.search.concat(props.moreSearch),
      loading: false,
      dataSource: [],
      page: {
        limit: 10,
        pageNumber: 1,
        total: 0,
      },
      currentSelection: [],
      filterText: null,
      dialogVisible: false,
      dialogModel: {},
      dialogCurTitle: null,
      curNode: null,
    });

    const getData = () => {
      basicTable.value.getData();
    };
    //点击树形
    const nodeClick = (node, treeParams) => {
      state.curNode = node[props.treeNodeKey];
      state.tableParamsObj = { ...state.tableParamsObj, ...treeParams };
      nextTick(() => {
        basicTable.value.getData();
      });
    };
    //点击搜索
    const handleSearch = () => {
      state.tableParamsObj = { ...state.tableParamsObj, ...state.form };
      nextTick(() => {
        basicTable.value.getData();
      });
    };
    /*重置搜索表单*/
    const resetSearch = () => {
      state.allSearch.forEach((item) => {
        state.form[item.value] =
          item.defaultValue || item.defaultValue === false
            ? item.defaultValue
            : null;
      });
      basicTable.value.page.pageNumber = 1;
      state.showMore = false;
      state.tableParamsObj = { ...state.tableParamsObj, ...state.form };
      nextTick(() => {
        basicTable.value.getData();
      });
    };
    //点击查看、详情、删除
    const handleClick = (type, item) => {
      switch (type) {
        case "detail":
          goDetail(type, item);
          break;
        case "edit":
          if (props.dialogForm && props.dialogForm.length > 0) {
            //新增编辑采用弹框模式
            state.dialogCurTitle = "编辑" + props.title;
            if (props.api.detail) {
              proxy.$api[props.api.detail](item[props.rowKey]).then((res) => {
                formDialog.value.dialogModel = props.afterGetDetail
                  ? props.afterGetDetail(res?.data ?? res)
                  : res?.data ?? res;
                state.dialogVisible = true;
              });
            } else {
              formDialog.value.dialogModel = props.afterGetDetail
                ? props.afterGetDetail(item)
                : JSON.parse(JSON.stringify(item));
              state.dialogVisible = true;
            }
          } else {
            goDetail(type, item);
          }
          break;
        case "delete":
          state.currentSelection = [item];
          handleDelete();
          break;
        case "export":
          handleExport("single", item);
          break;
        default:
          break;
      }
      emit("action", type, item);
    };
    //跳转到编辑、新增、详情页面
    const goDetail = (type, record) => {
      if (props.api.path) {
        let obj = {};
        if (props.api.pathParams && props.api.pathParams.length > 0) {
          //pathParams [{value:''}]
          props.api.pathParams.forEach((item) => {
            obj[item.value] = item.defaultValue
              ? item.defaultValue
              : record
              ? record[item.value]
              : null;
          });
        }

        router.push({
          path: props.api.path,
          query: {
            ...obj,
            type,
            id: record ? record[props.rowKey] : null,
          },
        });
      }
    };
    //导出、导入、批量删除、新增等
    const handleCommand = (command) => {
      let boo = props.beforeCommand ? props.beforeCommand() : true; //操作之前进行校验
      if (boo) {
        switch (command) {
          case "删除选中":
            handleDelete();
            break;
          case "删除全部":
            handleDeleteAll();
            break;
          case "导出选中":
            handleExport("multiple");
            break;
          case "导出全部":
            handleExportAll();
            break;
          case "export":
            handleExportAll();
            break;
          case "add":
            handleAdd();
            break;

          default:
            break;
        }
        emit("command", command, state.currentSelection);
      }
    };
    //删除
    const handleDelete = () => {
      if (state.currentSelection.length === 0) {
        proxy.$message.warning("请选择数据");
        return;
      }
      ElMessageBox.confirm("是否删除当前选中?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (props.api.delete) {
            const params = state.currentSelection.map(
              (item) => item[props.rowKey]
            );
            proxy.$api[props.api.delete](params.join(","), "delete").then(
              (res) => {
                basicTable.value.page.pageNumber = 1;
                ElMessage({
                  type: "success",
                  message: "删除成功",
                });
                basicTable.value.getData();
              }
            );
          }
        })
        .catch(() => {});
    };
    //删除全部
    const handleDeleteAll = () => {
      ElMessageBox.confirm("是否删除全部数据?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (props.api.deleteAll) {
            proxy.$api[props.api.deleteAll]().then((res) => {
              basicTable.value.page.pageNumber = 1;
              ElMessage({
                type: "success",
                message: "删除成功",
              });
              basicTable.value.getData();
            });
          }
        })
        .catch(() => {});
    };
    //导出
    const handleExport = (type, scope) => {
      if (props.api.export) {
        if (type === "multiple") {
          if (state.currentSelection.length > 0) {
            proxy
              .$confirm("是否确认导出内容,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                let ids = state.currentSelection.map(
                  (item) => item[props.rowKey]
                );
                // exportFile(
                //   props.api.export,
                //   { ids: ids.join(",") },
                //   props.title + ".xls"
                // );
              })
              .catch(() => {});
          } else {
            proxy.$message.warning("请选择数据");
          }
        } else {
          proxy
            .$confirm("是否确认导出内容,是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              // exportFile(
              //   props.api.export,
              //   { id: scope[props.rowKey] },
              //   props.title + ".xls",
              //   "formData"
              // );
            })
            .catch(() => {});
        }
      }
    };
    //导出全部
    const handleExportAll = () => {
      if (props.api.exportAll) {
        proxy
          .$confirm(`是否确认导出${props.title},是否继续?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            // exportFile(
            //   props.api.exportAll,
            //   { ...state.form, },
            //   props.title,
            //   "formData"
            // );
          });
      }
    };
    //点击新增
    const handleAdd = () => {
      if (props.dialogForm && props.dialogForm.length > 0) {
        //新增编辑采用弹框模式
        props.dialogForm.forEach((item) => {
          if (!formDialog.value.dialogModel[item.value]) {
            if (item.defaultValue !== undefined && item.defaultValue !== null) {
              formDialog.value.dialogModel[item.value] = item.defaultValue;
            } else {
              formDialog.value.dialogModel[item.value] = null;
            }
          }
        });
        state.dialogCurTitle = "新增" + props.title;
        state.dialogVisible = true;
      } else {
        if (props.api.path) {
          goDetail("add");
        }
      }
    };
    //表格选择
    const handleSelectionChange = (val) => {
      state.currentSelection = val;
    };
    //弹框点击保存
    const handleSubmit = (form) => {
      let params = props.beforeSave
        ? props.beforeSave({ ...form })
        : { ...form };
      // props.dialogForm.forEach(item=>{//删除多余的参数
      //   params[item.value] = formDialog.value.dialogModel[item.value]
      // })
      if (state.dialogCurTitle.indexOf("编辑") > -1 && props.api.edit) {
        proxy.$api[props.api.edit](params).then((res) => {
          basicTable.value.getData();
          state.dialogVisible = false;
          proxy.$message.success("保存成功");
        });
      }
      if (state.dialogCurTitle.indexOf("新增") > -1 && props.api.add) {
        proxy.$api[props.api.add](params).then((res) => {
          basicTable.value.getData();
          state.dialogVisible = false;
          proxy.$message.success("保存成功");
        });
      }
    };

    onMounted(() => {
      resetSearch();
      basicTable.value.getData();
    });
    // 把getData暴露给父组件调用
    // defineExpose({
    //   getData,
    // });
    return {
      basicTable,
      formDialog,
      ...toRefs(state),
      resetSearch,
      handleSearch,
      handleClick,
      handleSelectionChange,
      handleCommand,
      nodeClick,
      handleSubmit,
      getData,
    };
  },
});
</script>

<style lang="less" scoped>
.table-search {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  height: 32px;
  overflow: hidden;
  justify-content: space-between;
  .search-left {
    // width: calc(100% - 360px);
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    // align-items: center;
    > div {
      margin-right: 8px;
      &.search-left-small {
        width: 130px;
      }
      &.search-left-large {
        width: 300px;
      }
    }
  }
  .search-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .search-right-keywords {
      width: 200px;
      margin-right: 4px;
    }
    .search-right-filter {
      margin-right: 4px;
    }
  }
}
.table-container {
  height: calc(100% - 48px);
}
.table-pagination {
  text-align: right;
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.more-container {
  width: 100%;
  height: 100%;
  .more-container-title {
    width: 100%;
    height: 48px;
    display: flex;
    margin-bottom: 7px;
    .title-left {
      flex: 1;
      display: flex;
      .title-left-icon {
        height: 100%;
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f3f5f9;
        margin-right: 16px;
        cursor: pointer;
      }
      .title-left-text {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .title-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .more-container-body {
    width: 100%;
    height: calc(100% - 48px);
    .more-form {
      .more-form-item {
        display: flex;
        height: 32px;
        margin-bottom: 24px;
        .more-form-label {
          flex: 1;
          line-height: 32px;
        }
        .more-form-content {
          width: 318px;
        }
      }
    }
  }
}
.left-tree {
  margin-top: 5px;
}
.cur-node {
  background-color: #d9d9d9 !important;
}
</style>
